import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Button, Grid } from "@mui/material";
import { useEffect } from "react";
import Caracterizacion from "../../components/Form/Fields/Caracterizacion";
import CondicionesContexto from "../../components/Form/Fields/CondicionesContexto";
import TemaClase from "../../components/Form/Fields/TemaClase";
import ConexionesVidaRealCardImg from "../../components/UmmIApps/Cards/ConexionesVidaRealCardImg.png";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";
import CurriculumTabs from "../../components/CurriculumTabs/CurriculumTabs";
import { isSendButtonDisabled } from "../../config/sendButtonRules";


const GenerarConexionesPage = () => {

  const {
    nivelId,
    materiaId,
    promptData,
    handleBack,
    setTextoInicial,
    toggleCamposAvanzados,
    mostrarCamposAvanzados,
    handleNivelChange,
    handleAsignaturaChangeLocal,
    handleInitialPromptData,
    nivelTPId,
    asignaturaTPId,
    handleNivelTPChange,
    handleAsignaturaTPChangeLocal,
    clearTP,
    setPromptData
  } = useActividadesContext();


  //Variable para condicionar la habilitación del botón "Generar"
  const isButtonDisabled =  isSendButtonDisabled("conexiones_realidad", { promptData });
  const colorIconBack = "#BA4534";

  useEffect(() => {
    const init = {
      tema: "",
      caracterizacion: "",
      condiciones_contexto: "",
    };
    handleInitialPromptData(init, "conexiones_realidad");
    setTextoInicial(
      "Esta es la propuesta que tengo para ti.  Puedes revisarla y modificar cualquier parte según tus necesidades. Ajusta los parámetros en 'Mostrar campos', genera una nueva versión con 'Volver a generar' o personaliza el contenido con 'Editar'. Si prefieres trabajar en otra plataforma, usa 'Copiar' para llevar el texto donde desees."
    );
  }, []);

  return (
    <>
      <UmmiaAppsLayout
        onBack={handleBack}
        imageSrc={ConexionesVidaRealCardImg}
        backgroundColorImage={
          "linear-gradient(180deg, #FFFFFF 0%, #E3B5AE 100%, #C86A5D 100%)"
        }
        titleColor="#BA4534"
        title="Conexiones con la vida real"
        description="Establece vínculos entre el contenido curricular y situaciones reales de la vida cotidiana para que los estudiantes comprendan la relevancia y aplicabilidad de lo que están aprendiendo."
        isButtonDisabled={isButtonDisabled}
        colorIconBack={colorIconBack}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            
              <CurriculumTabs
                nivelId={nivelId}
                materiaId={materiaId}
                nivelTPId={nivelTPId}
                asignaturaTPId={asignaturaTPId}
                handleNivelChange={handleNivelChange}
                handleNivelTPChange={handleNivelTPChange}
                handleAsignaturaChangeLocal={handleAsignaturaChangeLocal}
                handleAsignaturaTPChangeLocal={handleAsignaturaTPChangeLocal}
                clearTP={clearTP}
                promptData={promptData}
                setPromptData={setPromptData}
              />
        
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          lg={12}
          display={"flex"}
          flexDirection={"row"}
          sx={{ mt: 4 }}
        >
          <TemaClase />
        </Grid>

        <Grid item xs={12} container justifyContent="center" sx={{ mb: 3 }}>
          <Button
            variant="text"
            sx={{ color: "#336B87" }}
            onClick={toggleCamposAvanzados}
            endIcon={
              mostrarCamposAvanzados ? <ExpandLessIcon /> : <ExpandMoreIcon />
            }
          >
            {mostrarCamposAvanzados
              ? "Ocultar opciones avanzadas"
              : "Mostrar opciones avanzadas (opcional)"}
          </Button>
        </Grid>
        {/* Campos avanzados */}
        {mostrarCamposAvanzados && (
          <>
            <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
              <CondicionesContexto />
            </Grid>

            <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
              <Caracterizacion />
            </Grid>
          </>
        )}
      </UmmiaAppsLayout>
    </>
  );
};

export default GenerarConexionesPage;
